import { SpaPackageAvailabilityConnected as SpaPackageAvailability } from './container';

export { SpaPackageAvailability };
